import {React, useEffect, useRef} from "react";
import { Link } from "react-router-dom";
import useAxiosIntercept from "../../../hooks/useAxiosIntercept";
import useLogout from "../../../hooks/useLogout";
import useOutsideClick from "../../../hooks/useOutsideClick";
import useAuth from "../../../hooks/useAuth";

const Header = () => {
  const logout = useLogout();
  const popupref = useRef();
  const {auth , setAuth}=useAuth();
  const ref = useRef(true);
  const axiosPrivate = useAxiosIntercept();

  useOutsideClick(popupref , () => {
    document.querySelector('.userNav .dropMenu').style.display = 'none';
    document.querySelector(".userNav").classList.remove("open");
  });

  const loggingOut = async () => {
    const response = await logout();
  };

  useEffect(()=>{
    if(ref.current == true){
      ref.current = false;
      if((auth.userName=="") || (auth.userIsRoot == undefined || auth.userIsRoot == "") || (auth.wallet_id == undefined || auth.wallet_id =="")) {
        getuserDetalis();
      }
    }
  },[])

  const getuserDetalis = async () => {
    const URL = process.env.REACT_APP_GET_SINGLE_USER;
    try {
      const response = await axiosPrivate.get(
          URL
      );
      if(response?.data?.response?.data?.user_info!= null){
        setAuth((prev) => {
          return {
            ...prev,
            userName:response?.data?.response?.data?.user_info.firstname,
            userEmail:response?.data?.response?.data?.user_info.email,
            userLastName:response?.data?.response?.data?.user_info.lastname,
            userImage: response?.data?.response?.data?.user_info.user_image,
            userIsRoot: response?.data?.response?.data?.user_info.is_root,
            partner_id : response?.data?.response?.data?.user_info.partner?.partner_id,
            is_corporate : response?.data?.response?.data?.user_info.partner?.is_corporate,
            wallet_id : response?.data?.response?.data?.user_info.partner?.wallet_id,
            partner_logo :  response?.data?.response?.data?.user_info.partner?.partner_logo,
          };
        });
      }

    } catch (err) {
      console.error("something went wrong", err);
    }
  }
  const profile = () => {
    var container = document.querySelector('.userNav .dropMenu');
    var navContainer = document.querySelector(".userNav");
    container.style.display = (container.style.display == 'block'?'none':'block');
    navContainer.classList.toggle("open");

    if(auth.userName=="")
    {
      getuserDetalis();
    }
  }

  return (
    <div className="headerWrap">
      <div className="header">
        <span></span>
        <div className="userNav" onClick={profile}  ref={popupref}>
          {auth.userImage && auth.userImage!= undefined ? <i className="userAvtar"><img src={auth.userImage} style={{overflow:"hidden"}}></img></i> : (auth.userName && auth.userName != undefined ? <i className="userAvtar">{auth.userName.charAt(0).toUpperCase()}</i> : <i className="userAvtar">User</i> )}
          <ul className="dropMenu" style={{ display: "none" }}>
            <li className="profileTxt">
              <Link to="">
                {auth.userImage && auth.userImage!= undefined ? <i className="userAvtar ml-0 mr-12"><img src={auth.userImage} style={{overflow:"hidden"}}></img></i> : (auth.userName && auth.userName != undefined ? <i className="userAvtar ml-0 mr-12">{auth.userName.charAt(0).toUpperCase()}</i> : <i className="userAvtar ml-0 mr-12">User</i> )}
                {/*<i className="userAvtar">*/}
                {/*  <img src={auth.userImage}/>*/}
                {/*</i>*/}
                <span>{auth.userName?`${auth.userName}`:"Guest"}
                  <em>
                    {auth.userEmail}
                  </em>
                </span>
              </Link>
            </li>
            {/*<li>*/}
            {/*  <Link to="">Profile</Link>*/}
            {/*</li>*/}
            <li >
              <Link style={{color: "red"}} to="" onClick={loggingOut}>Logout</Link>
            </li>
          </ul>
        </div>
      </div></div>
    
  );
};

export default Header;
